module.exports = __webpack_public_path__ + "img/tan.f83d21f0.svg";